import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { Fonts, Spacings, breakpoints } from '@styles/index';

const H4 = styled.h4`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H4};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    font-size: 16px;
    line-height: 100%;
  }
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default H4;

H4.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

H4.defaultProps = {
  color: 'var(--color-text-primary)',
  lineClamp: null
};
